// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Morocco from '../_raw/flag/icon_flag_morocco.png';

export default () => <img src={Morocco} alt="Morocco" />;
